import React from "react";
import { Hero } from "../components/sales/Hero";
import { Problem } from "../components/sales/Problem";
import { SystemWorkflow } from "../components/sales/SystemWorkflow";
import { PracticalBenefits } from "../components/sales/PracticalBenefits";
import { Volumes } from "../components/sales/Volumes";
import { LookInside } from "../components/sales/LookInside";
import { Bonuses } from "../components/sales/Bonuses";
import { Checkout } from "../components/sales/Checkout";
import { Differentiation } from "../components/sales/Differentiation";
import { Guarantee } from "../components/sales/Guarantee";
import { Testimonials } from "../components/sales/Testimonials";
import { CtaBand } from "../components/sales/CtaBand";
import { FaqSection } from "../components/sales/FaqSection";
import { FinalClose } from "../components/sales/FinalClose";
import { Footer } from "../components/sales/Footer";
import { PurchasePopup } from "../components/sales/PurchasePopup";
export function SalesPage() {
  return <div className="min-h-screen w-full bg-white font-sans text-navy" data-id="element-300" data-mp="3akrvtsfn6e3u">
      <Hero data-id="element-301" data-mp="35t9tazxz05gr" />
      <main data-id="element-302" data-mp="35si1m07hurvr">
        <Problem data-id="element-303" data-mp="35rypx18fszq6" />
        <SystemWorkflow data-id="element-304" data-mp="35rf9xq2ckles" />
        <PracticalBenefits data-id="element-305" data-mp="35r6ubqeub1zw" />
        <Volumes data-id="element-306" data-mp="30tdpp1t6qg1q" />
        <LookInside data-id="element-307" data-mp="30uykmsjew104" />
        <Bonuses data-id="element-308" data-mp="30uge9331c6eh" />
        <Checkout data-id="element-309" data-mp="30rualej9mb1j" />
        <Differentiation data-id="element-310" data-mp="2vuu4j3mf18af" />
        <CtaBand label="Yes! I want the complete system" data-id="element-311" data-mp="2vvln9duwzbja" />
        <Guarantee data-id="element-312" data-mp="2vszexc078s00" />
        <Testimonials data-id="element-313" data-mp="3tic8m154tm83" />
        <CtaBand label="Join these coaches today" data-id="element-314" data-mp="3thjblrvz6b35" />
        <FaqSection data-id="element-315" data-mp="3tg89dwi6hbe5" />
        <FinalClose data-id="element-316" data-mp="3ojraq8dcremt" />
      </main>
      <Footer data-id="element-317" data-mp="3okswb6rzvjis" />
      <PurchasePopup data-id="element-318" data-mp="3ok1322lvdxvo" />
    </div>;
}